import { render, staticRenderFns } from "./CreatePostModal.vue?vue&type=template&id=64de5682"
import script from "./CreatePostModal.vue?vue&type=script&lang=js"
export * from "./CreatePostModal.vue?vue&type=script&lang=js"
import style0 from "./CreatePostModal.vue?vue&type=style&index=0&id=64de5682&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports